function gameSelect(item) {
  window.localStorage.setItem('game_server', item)
  const saveUser = JSON.parse(window.localStorage.getItem('save'))
  const vgpId = window.localStorage.getItem('userId')

  if (saveUser !== null) {
    const getUser = saveUser.filter(item => item.id === vgpId)
    if (getUser[0] !== undefined) {
      const data = getUser[0].data
      if (data) {
        const name = data.filter(name => name.game_server === item)
        if (name[0] !== undefined) {
          this.$store.commit('SERVER_REQUEST', name[0].list)
          this.$store.dispatch('CHARACTER_REQUEST', {
            game_id: name[0].game_id,
            user_id: name[0].user_id,
            server_id: name[0].server_id,
          })
          this.group_server = name[0].server_group
          this.server = name[0].server_name
          this.character = name[0].character_name
          this.character_id = name[0].character_id
          this.server_id = name[0].server_id
        } else {
          this.$refs.group_server.reset()
          this.$refs.server.reset()
          this.$refs.character.reset()
        }
      }
    }
  }

  if (!this.$route.params.id) {
    const id = this.games.filter(id => id.name === item)
    id.forEach(element => {
      if (element.id) {
        window.localStorage.setItem('game_id', element.id)
        this.game_id = element.id
        this.$store.dispatch('SERVER_REQUEST', {
          game_id: element.id,
        })
      }
    })
  } else {
    this.$store.dispatch('SERVER_REQUEST', {
      game_id: window.localStorage.getItem('game_id'),
    })
    this.$refs.character.reset()
  }
}

function groupServerSelect(item) {
  window.localStorage.setItem('server_group', item)
  const saveUser = JSON.parse(window.localStorage.getItem('save'))
  const vgpId = window.localStorage.getItem('userId')
  const gameId = window.localStorage.getItem('game_id')
  const name = window.localStorage.getItem('server_group')
  // Lấy danh sách server theo cụm
  this.groups.filter(element => {
    if (element.name === name) {
      window.localStorage.setItem(
        'server_by_group',
        JSON.stringify(element.list)
      )
      this.$store.commit('SERVER_REQUEST', element.list)
    }
  })
  // Check xem saveUser có null không
  if (saveUser !== null) {
    // Nếu trùng vgpId với user đã lưu
    const getUser = saveUser.filter(item => item.id === vgpId)
    if (getUser[0] !== undefined) {
      // Nếu có data
      const data = getUser[0].data
      if (data) {
        data.forEach(element => {
          const sameGame = data.filter(id => id.game_id === gameId)
          const otherGame = data.filter(id => id.game_id !== gameId)
          if (sameGame[0] !== undefined && otherGame[0] === undefined) {
            // Case 1: Chỉ có cùng game
            if (item !== element.server_group) {
              // Cùng game khác cụm
              this.$refs.server.reset()
              this.$refs.character.reset()
            }

            if (item === element.server_group) {
              window.localStorage.setItem('server_name', element.server_name)
              window.localStorage.setItem(
                'character_name',
                element.character_name
              )
              // Cùng game cùng cụm
              this.$store.dispatch('CHARACTER_REQUEST', {
                game_id: element.game_id,
                user_id: element.user_id,
                server_id: element.server_id,
              })
              this.server = element.server_name
              this.character = element.character_name
            }
          }

          if (sameGame[0] !== undefined && otherGame[0] !== undefined) {
            // Case 2: Cả cùng game cả khác game
            if (element.game_id === gameId) {
              // Chỉ lấy cùng game
              if (item !== element.server_group) {
                // Cùng game khác cụm
                this.$refs.server.reset()
                this.$refs.character.reset()
              }

              if (item === element.server_group) {
                window.localStorage.setItem('server_name', element.server_name)
                window.localStorage.setItem(
                  'character_name',
                  element.character_name
                )
                // Cùng game cùng cụm
                this.$store.dispatch('CHARACTER_REQUEST', {
                  game_id: element.game_id,
                  user_id: element.user_id,
                  server_id: element.server_id,
                })
                this.server = element.server_name
                this.character = element.character_name
              }
            }
          }

          if (sameGame[0] === undefined && otherGame[0] !== undefined) {
            // Case 3: Chỉ có khác game
            this.$refs.server.reset()
            this.$refs.character.reset()
          }
        })
      }
    }
  }
}
function serverSelect(item) {
  window.localStorage.setItem('server_name', item)
  const saveUser = JSON.parse(window.localStorage.getItem('save'))
  const vgpId = window.localStorage.getItem('userId')
  const gameId = window.localStorage.getItem('game_id')
  const serverId = this.servers.filter(serverId => serverId.name === item)
  serverId.forEach(element => {
    this.server_id = element.id
    if (!this.$route.params.id) {
      this.$store.dispatch('CHARACTER_REQUEST', {
        game_id: window.localStorage.getItem('game_id'),
        user_id: window.localStorage.getItem('userId'),
        server_id: element.id,
      })
    } else {
      this.$store.dispatch('CHARACTER_REQUEST', {
        game_id: window.localStorage.getItem('game_id'),
        user_id: window.localStorage.getItem('userId'),
        server_id: element.id,
      })
    }
  })
  // Check xem saveUser có null không
  if (saveUser !== null) {
    const getUser = saveUser.filter(item => item.id === vgpId)
    if (getUser[0] !== undefined) {
      const data = getUser[0].data
      if (data) {
        const sameGame = data.filter(id => id.game_id === gameId)
        const otherGame = data.filter(id => id.game_id !== gameId)
        data.forEach(element => {
          if (sameGame[0] !== undefined && otherGame[0] === undefined) {
            // Case 1: Chỉ có cùng game
            if (element.server_name !== item) {
              this.$refs.character.reset()
            }

            if (element.server_name === item) {
              this.character = element.character_name
            }
          }

          if (sameGame[0] !== undefined && otherGame[0] !== undefined) {
            // Case 2: Cả cùng game cả khác game
            if (element.game_id === gameId) {
              // Chỉ lấy cùng game
              if (item !== element.server_name) {
                // Cùng game khác cụm
                this.$refs.character.reset()
              }

              if (item === element.server_name) {
                // Cùng game cùng cụm
                this.character = element.character_name
              }
            }
          }

          if (sameGame[0] === undefined && otherGame[0] !== undefined) {
            // Case 3: Chỉ có khác game
            this.$refs.character.reset()
          }
        })
      }
    }
  }
}
function characterSelect(item) {
  window.localStorage.setItem('character_name', item)
  const characterId = this.characters.filter(
    characterId => characterId.name === item
  )
  characterId.forEach(element => {
    this.character_id = element.id
  })
}

export { gameSelect, groupServerSelect, serverSelect, characterSelect }
